import request from '../utils/request.js'

export function getOnlineExam(){
    return request({
        url:'/getOnlineExam',
        method:'get'
    })
}
export function getExamQue(data){
    return request({
        url:'/getExamQue?examId='+data,
        method:'get'
    })
}
export function saveExam(data){
    return request({
        url:'/saveOnlineExam',
        method:'post',
        data:data
    })
}
export function compareFace(data){
    return request({
        url:'/compareFace',
        method:'post',
        data:data
    })
}